import { prefixObjectValues } from '../utils';

const modal = {
  form: 'form',
  firstName: 'firstName',
  lastName: 'lastName',
  emailAddress: 'email',
  phoneNumber: 'phoneNumber',
  relationshipType: 'relationshipType',
  closeBtn: 'closeBtn',
  submitBtn: 'submitBtn',
  pendingExistsMsg: 'pendingExistsMsg',
  resendPendingBtn: 'resendPendingBtn',
  cancelPendingBtn: 'cancelPendingBtn',
};

export default prefixObjectValues(modal, 'peer-reference-form');
